import { connect } from 'react-redux'
import {
  archiveBoard,
  unarchiveBoard,
  deleteBoard,
  duplicateBoard
} from '../../store/actions/boards'
import {
  archiveFolder,
  unarchiveFolder,
  deleteFolder
} from '../../store/actions/folders'
import { leaveShare } from '../../store/actions/share'
import { compose, withHandlers } from 'recompose'
import { push } from 'react-router-redux'
import { withTranslation } from 'react-i18next'
import { accessListSelector } from '../../store/selectors/accessSelectors'
import { EDITOR } from '../../constants'
import { userSelector } from '../../store/selectors/baseSelectors'
import { confirm, showAlert } from '../../store/actions/alerts'
import i18n from '../../../i18n'
import { setEditingItem } from '../../store/actions/sidebar'

export default compose(
  connect(
    (state, { itemId }) => {
      const user = userSelector(state)
      if (user.isEmpty || user.isAnonymous) return { anon: true }

      const accessList = accessListSelector(state)
      const item = accessList[itemId]

      // can leave if you are not the owner
      let canLeave = !item.isOwner

      // can't leave an item if you are a member of an ancestor - must leave that share
      let checkItem = item
      while (checkItem && checkItem.parent) {
        const parent = accessList[checkItem.parent]
        if (parent && parent.shareId) canLeave = false
        checkItem = parent
      }

      return {
        item,
        canLeave,
        editor: item.accessLevel >= EDITOR,
        canMove:
          !item.parent ||
          (accessList[item.parent] && accessList[item.parent].accessLevel),
        archvied: item.dateArchived
      }
    },
    {
      setEditingItem,
      leaveShare,
      push,
      duplicateBoard,
      confirm,
      deleteBoard,
      deleteFolder,
      archiveBoard,
      archiveFolder,
      unarchiveBoard,
      unarchiveFolder,
      showAlert
    }
  ),
  withHandlers({
    rename: ({ item, setEditingItem }) => () => setEditingItem(item.id),
    leave: ({ item, leaveShare }) => () => {
      leaveShare(item.id)
      if (window.location.pathname.includes(item.id)) push('/')
    },
    duplicate: ({ item, duplicateBoard }) => () => duplicateBoard(item.id),
    remove: ({ item, confirm, deleteBoard, deleteFolder, push }) => () => {
      confirm('globalNav.confirmDelete', () => {
        item.type === 'board' ? deleteBoard(item) : deleteFolder(item)
        if (window.location.pathname.includes(item.id)) push('/')
      })
    },
    archive: ({ item, archiveBoard, archiveFolder, push }) => () => {
      item.type === 'board' ? archiveBoard(item) : archiveFolder(item)

      if (window.location.pathname.includes(item.id)) push('/')
    },
    unarchive: ({ item, unarchiveBoard, unarchiveFolder }) => () => {
      item.type === 'board' ? unarchiveBoard(item) : unarchiveFolder(item)
    },
    handleClickInside: ({ hide }) => e => {
      e.stopPropagation() // prevent clicks in the menu counting as clicks on the item
      hide()
    },
    showCantMoveAlert: ({ item, showAlert }) => () => {
      showAlert(null, i18n.t('sidebar.cantMove', item))
    }
  }),
  withTranslation()
)
